import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2e5d5456&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e5d5456",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\iot_vehicle\\iot_frontend\\iot_supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e5d5456')) {
      api.createRecord('2e5d5456', component.options)
    } else {
      api.reload('2e5d5456', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2e5d5456&scoped=true&", function () {
      api.rerender('2e5d5456', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/service/list/index.vue"
export default component.exports